import { useNavigate } from 'react-router-dom';
import EntityDialog from '../../EntityDialog';
import { showToastError } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { addFacility } from '../../hooks/useFacilities';
import { getMarkets } from '../../hooks/useMarkets';

export default function AddFacilityContainer() {
  const navigate = useNavigate();
  const { org } = useLegacyAppSession();

  return (
    <EntityDialog
      testId="add-facility"
      title="Add Facility"
      contextLabel="Facilities"
      fields={[
        { name: 'name', label: 'Facility Name', required: true },
        { name: 'license', label: 'License', required: true },
        { name: 'metrcFacilityId', label: 'Metrc Facility ID', required: false },
      ]}
      initialValues={{ name: '', license: '', metrcFacilityId: '' }}
      onClose={() => navigate('/imports?tab=facilities', { replace: true })}
      onSave={async (payload) => {
        if (!org?.id) return;

        try {
          const markets = await getMarkets(org.id);
          const marketId = markets && markets.length ? markets[0].id : null;

          if (!marketId) {
            showToastError('No market available for the selected organization.');
            return;
          }

          await addFacility({
            organizationId: org.id,
            marketId,
            name: payload.name,
            license: payload.license,
            metrcFacilityId: Number(payload.metrcFacilityId) || 0,
          });

          navigate('/imports?tab=facilities', { replace: true });
        } catch (error) {
          console.error(error);
          showToastError('Facility could not be added.');
        }
      }}
    />
  );
}
